import { useAccount } from 'hooks/useAccount';
import { Navigate } from 'react-router-dom';

export const PlatformRoute = ({ children }: { children: React.ReactNode }) => {
  const { canManageCentralCompanies } = useAccount();

  if (!canManageCentralCompanies) {
    return <Navigate to="/app/desktop" replace />;
  }

  return <>{children}</>;
};
